export const RESTART_ON_REMOUNT = '@@saga-injector/RESTART-ON-REMOUNT';
export const DAEMON = '@@saga-injector/DAEMON';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/ONCE-TILL-UNMOUNT';
